// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '@/store/index'

const state = () => ({
  tableHeaders: [
    {
      title: 'Проекты',
      isSortable: false,
      allActive: false
    }
  ],
  projects: [],
  modal: {
    active: false,
    updatedId: null,
    name: '',
    validation: {
      name: { type: null, message: '' }
    }
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  isActiveDelete: false
})

const getters = {
  getContractsProjectList: state => state.projects,
  getContractsProjectListTableHeaders: state => state.tableHeaders,
  getContractsProjectListModal: state => state.modal,
  getContractsProjectListSearchValue: state => state.searchValue,
  getContractsProjectListFilter: state => state.filter,
  getContractsProjectListPagination: state => state.pagination,
  toggleContractsProjectListPageList: state => state.pagination,
  getContractsProjectListIsLoading: state => state.isLoading,
  getContractsProjectListResponseModal: state => state.responseModal,
  getContractsProjectListResponseModalWithTreaties: state => state.responseModalWithTreaties,
  getContractsProjectListActiveDelete: state => state.isActiveDelete
}

const mutations = {
  GET_CONTRACTS_PROJECTS: (state, projects) => {
    state.projects = projects.data.map(project => {
      return {
        ...project,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  TOGGLE_CONTRACTS_PROJECT_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.projects.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  SHOW_CONTRACTS_PROJECT_LIST_MODAL: (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedProject = state.projects.filter(project => {
        return project.id === itemId
      }).pop()

      state.modal.updatedId = itemId
      state.modal.name = selectedProject.name
      state.modal.color = selectedProject.color
    }
  },
  SET_CONTRACTS_PROJECT_ITEM_NAME: (state, value) => {
    state.modal.name = value
  },
  SET_CONTRACTS_PROJECT_ITEM_VALIDATION: (state, valid) => {
    state.modal.validation.name.message = valid.name[0]
    state.modal.validation.name.type = 'error'
  },
  CLEAR_CONTRACTS_PROJECT_MODAL_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = { type: null, message: '' }
        break
      default:
        break
    }
  },
  CLOSE_CONTRACTS_PROJECT_LIST_MODAL: (state) => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.validation.name = { id: null, message: '' }
  },

  // pagination
  SET_CONTRACTS_PROJECT_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  RESET_CONTRACTS_PROJECT_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },

  // search
  SET_CONTRACTS_PROJECT_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  TOGGLE_CONTRACTS_PROJECT_LIST_FILTER: (state) => {
    state.filter.active = !state.filter.active
  },

  // delete checked items
  DELETE_CONTRACTS_PROJECT_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили проект(ы)'
    state.responseModal.type = 'main'
  },
  DELETE_CONTRACTS_PROJECT_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении проекта произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },

  DELETE_CONTRACTS_PROJECT_LIST_CHECKED_ITEMS_TREATIES_ERROR: (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModalWithTreaties.isActive = true
    state.responseModalWithTreaties.text = `Данные проекты используются в договорах:${listNamesErrorItems}`
    state.tableHeaders.allActive = false
  },
  CLOSE_DELETE_CONTRACTS_PROJECT_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  CLOSE_DELETE_CONTRACTS_PROJECT_LIST_MODAL_WITH_TREATIES: (state) => {
    state.responseModalWithTreaties.isActive = false
    state.responseModalWithTreaties.text = ''
  },
  TOGGLE_CONTRACTS_PROJECT_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.projects.length
    let counter = 0

    state.projects.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_CONTRACTS_PROJECT_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false
    state.projects.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  RESET_CONTRACTS_PROJECT_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.projects.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  // reset store
  RESET_CONTRACTS_PROJECT_LIST_STORE: (state) => {
    // state.searchValue = ''
    state.isActiveDelete = false
    state.tableHeaders.allActive = false
    state.pagination.currentPage = 1
  }
}

const actions = {
  getContractsProject ({ commit, state, dispatch }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''

    axios.get(`${url}/treaties-project?expand=treaties&${searchFilter}&per-page=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTS_PROJECTS', response.data)
      commit('SET_CONTRACTS_PROJECT_LIST_PAGINATION', response.headers)
      state.isLoading = false
    }).catch(error => {
      console.log('ошибка получения списка контрагентов', error)
    })
  },
  saveContractsProjectItem ({ commit, state, dispatch }) {
    if (!state.modal.updatedId) {
      const createData = {
        name: state.modal.name,
        color: state.modal.color
      }
      axios.post(`${url}/treaties-project`, createData, config).then(response => {
        commit('CLOSE_CONTRACTS_PROJECT_LIST_MODAL')
        dispatch('getContractsProject')
      }).catch(error => {
        commit('SET_CONTRACTS_PROJECT_ITEM_VALIDATION', error.response.data.errors)
        console.log('Ошибка обновления договора', error.response)
      })
    } else {
      const updateData = {
        name: state.modal.name,
        color: state.modal.color
      }

      axios.put(`${url}/treaties-project/${state.modal.updatedId}`, updateData, config).then(response => {
        commit('CLOSE_CONTRACTS_PROJECT_LIST_MODAL')
        dispatch('getContractsProject')
      }).catch(error => {
        commit('SET_CONTRACTS_PROJECT_ITEM_VALIDATION', error.response.data.errors)
        console.log('Ошибка обновления договора', error.response)
      })
    }
  },
  toggleContractsProjectListItemControls ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTS_PROJECT_LIST_ITEM_CONTROLS', itemId)
  },
  closeContractsProjectListItemControls ({ commit }, itemId) {
    commit('CLOSE_CONTRACTS_PROJECT_LIST_ITEM_CONTROLS', itemId)
  },
  toggleContractsProjectListItemActive ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTS_PROJECT_LIST_ITEM_ACTIVE', itemId)
  },
  toggleContractsProjectListItemActiveAll ({ commit }) {
    commit('TOGGLE_CONTRACTS_PROJECT_LIST_ITEM_ACTIVE_ALL')
  },
  showContractsProjectModal ({ commit }, itemId) {
    commit('SHOW_CONTRACTS_PROJECT_LIST_MODAL', itemId)
  },
  setContractsProjectItemName ({ commit }, value) {
    commit('SET_CONTRACTS_PROJECT_ITEM_NAME', value)
  },
  clearContractsProjectModalValidation ({ commit }, inputName) {
    commit('CLEAR_CONTRACTS_PROJECT_MODAL_VALIDATION', inputName)
  },
  closeContractsProjectModal ({ commit }) {
    commit('CLOSE_CONTRACTS_PROJECT_LIST_MODAL')
  },
  removeContractsProject ({ dispatch }, itemId) {
    axios.delete(`${url}/treaties-project/${itemId}`, config).then(response => {
      dispatch('getContractsProject')
    }).catch(error => {
      console.log('Ошибка удаления стадии:' + error)
    })
  },

  // pagination
  getContractsProjectListPage ({ state, commit }, pageNum) {
    const searchFilter = state.searchValue ? `search[all]=${state.searchValue}` : ''
    const currentTake = state.pagination.currentTake
    const currentPage = pageNum

    axios.get(`${url}/treaties-project?${searchFilter}&orderBy=id&orderDir=DESC&per-page=${currentTake}&page=${currentPage}`, config).then(response => {
      commit('GET_CONTRACTS_PROJECTS', response.data)
      commit('SET_CONTRACTS_PROJECT_LIST_PAGINATION', response.headers)
    })
  },
  resetContractsProjectListCurrentPage ({ commit }) {
    commit('RESET_CONTRACTS_PROJECT_LIST_CURRENT_PAGE')
  },

  // search
  setContractsProjectListSearchValue ({ commit, dispatch }, searchValue) {
    commit('SET_CONTRACTS_PROJECT_LIST_SEARCH_VALUE', searchValue)
    commit('RESET_CONTRACTS_PROJECT_LIST_CURRENT_PAGE')
    dispatch('getContractsProject')
  },

  // delete checked items
  deleteContractsProjectListCheckedItems ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    const treatiesItems = []
    state.projects.forEach((e) => {
      if (e.isActive && e.treaties === null) {
        checkedItems.push(e)
      } else if (e.isActive && e.treaties) {
        treatiesItems.push(e)
      }
    })

    if (treatiesItems.length > 0) {
      commit('DELETE_CONTRACTS_PROJECT_LIST_CHECKED_ITEMS_TREATIES_ERROR', treatiesItems)

      treatiesItems.forEach((e) => {
        e.isActive = false
      })
    }

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/treaties-project/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления проекта', error)
        })
      }
    }

    if (checkedItems.length > 0) {
      processMessages(checkedItems).then(() => {
        if (errorItems.length > 0) {
          commit('RESET_CONTRACTS_PROJECT_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTS_PROJECT_LIST_CHECKED_ITEMS_ERROR', errorItems)
          dispatch('getContractsProject')
        } else {
          commit('RESET_CONTRACTS_PROJECT_LIST_ALL_CHECKS')
          commit('DELETE_CONTRACTS_PROJECT_LIST_CHECKED_ITEMS_SUCCESS')
          dispatch('getContractsProject')
        }
      })
    }
  },
  closeContractsProjectListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTS_PROJECT_LIST_MODAL')
  },
  closeContractsProjectListDeleteModalWithTreaties ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTS_PROJECT_LIST_MODAL_WITH_TREATIES')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
